module.exports = __webpack_public_path__ + "img/categorie-nos-prestations-famille-boutrais-small.70cff0a3.jpg";